import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SCENE } from "@/lib/categoryAssets";

export default function HomeLanding() {
  return (
    <div className="max-w-5xl mx-auto px-5 md:px-8 py-16 md:py-24 min-h-[70vh]">
      <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-center">
        <p className="font-sans text-[10px] tracking-luxe uppercase text-[#C8A97E]">MOIRÉ Home</p>
        <h1 className="font-serif text-5xl md:text-6xl text-[#F5F2EA] mt-3">Dress Your Space.</h1>
        <p className="font-serif italic text-lg md:text-xl text-[#F5F2EA]/70 mt-4">Your personal interior styling intelligence — style the space you already have.</p>
      </motion.div>

      <div className="grid sm:grid-cols-2 gap-5 mt-14">
        <Link to="/home/style-piece" data-testid="home-cta-piece" className="group border border-[#F5F2EA]/12 hover:border-[#C8A97E] transition-colors overflow-hidden">
          <div className="aspect-[4/3] overflow-hidden bg-[#141414]">
            <img src={SCENE.myHome} alt="A styled armchair, side table and lamp" loading="lazy"
              className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700" />
          </div>
          <div className="p-8">
            <h2 className="font-serif text-3xl text-[#F5F2EA]">Style A Piece</h2>
            <p className="font-serif italic text-base text-[#F5F2EA]/70 mt-1">Show me something you already own.</p>
            <span className="inline-flex items-center gap-2 mt-5 font-sans text-[10px] tracking-luxe uppercase text-[#C8A97E]">Start <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" /></span>
          </div>
        </Link>
        <Link to="/home/room" data-testid="home-cta-room" className="group border border-[#F5F2EA]/12 hover:border-[#C8A97E] transition-colors overflow-hidden">
          <div className="aspect-[4/3] overflow-hidden bg-[#141414]">
            <img src={SCENE.roomCard} alt="A warm, styled living room with art, lamp and sofa" loading="lazy"
              className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700" />
          </div>
          <div className="p-8">
            <h2 className="font-serif text-3xl text-[#F5F2EA]">Check My Room</h2>
            <p className="font-serif italic text-base text-[#F5F2EA]/70 mt-1">Show me your space.</p>
            <span className="inline-flex items-center gap-2 mt-5 font-sans text-[10px] tracking-luxe uppercase text-[#C8A97E]">Start <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" /></span>
          </div>
        </Link>
      </div>
      <p className="font-sans text-xs text-[#8A8170] text-center mt-8">MOIRÉ styles the space you have — it never demolishes your room to invent a random interior. Your photos stay private.</p>
    </div>
  );
}
